// import { InfoPageHero } from '../components/layout/components/InfoPageHero'
import { graphql, useStaticQuery } from "gatsby";
import { Layout } from "../components/layout/layout";

import * as React from "react";
import { InfoPageHero } from "../components/layout/info-hero";
import { LocationType } from "../interfaces";

const AboutUsPage = ({ location }: { location: LocationType }) => {
    const data: {
        frontmatter: { description: string; title: string };
        html: string;
    } = useStaticQuery(graphql`
        {
            markdownRemark(frontmatter: { key: { eq: "about-us" } }) {
                html
                frontmatter {
                    description
                    title
                }
            }
        }
    `).markdownRemark;

    return (
        <Layout
            title={data.frontmatter.title}
            description={data.frontmatter.description}
            path="/about-us/"
        >
            <InfoPageHero
                title={data.frontmatter.title}
                centered={true}
            ></InfoPageHero>
            <div
                className={`article about-us w-text-article m-auto px-2 pt-8`}
                dangerouslySetInnerHTML={{ __html: data.html }}
            />
        </Layout>
    );
};
export default AboutUsPage;
